import styled from "styled-components";

// 1. Убираем фон и 'fixed', добавляем позиционирование
export const Container = styled.main`
    position: relative;
    overflow: hidden;
    /* background-image: url("./img/13-ppa-images.jpg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-attachment: fixed; 
    */
`